// import React, { useEffect } from "react";
// import avatar from "assets/img/avatars/avatar4.png";

// const EntriesAndExits = () => {
//   const [data, setData] = React.useState([]);

//   useEffect(() => {
//     setData([
//       {
//         name: "Vlad Mihalache",
//         avatar: avatar,
//         role: "Volunteer",
//         service: "Service Name",
//         datetime: new Date(),
//         type: Math.random() > 0.5 ? "Entry" : "Exit",
//       },
//       {
//         name: "John Smith",
//         avatar: avatar,
//         role: "Volunteer",
//         service: "Service Name",
//         datetime: new Date(),
//         type: Math.random() > 0.5 ? "Entry" : "Exit",
//       },
//       {
//         name: "Emma Johnson",
//         avatar: avatar,
//         role: "Volunteer",
//         service: "Service Name",
//         datetime: new Date(),
//         type: Math.random() > 0.5 ? "Entry" : "Exit",
//       },
//       {
//         name: "Emma Johnson",
//         avatar: avatar,
//         role: "Volunteer",
//         service: "Service Name",
//         datetime: new Date(),
//         type: Math.random() > 0.5 ? "Entry" : "Exit",
//       },
//       {
//         name: "Emma Johnson",
//         avatar: avatar,
//         role: "Volunteer",
//         service: "Service Name",
//         datetime: new Date(),
//         type: Math.random() > 0.5 ? "Entry" : "Exit",
//       },
//       {
//         name: "Emma Johnson",
//         avatar: avatar,
//         role: "Volunteer",
//         service: "Service Name",
//         datetime: new Date(),
//         type: Math.random() > 0.5 ? "Entry" : "Exit",
//       },
//       {
//         name: "Emma Johnson",
//         avatar: avatar,
//         role: "Volunteer",
//         service: "Service Name",
//         datetime: new Date(),
//         type: Math.random() > 0.5 ? "Entry" : "Exit",
//       },
//     ]);
//   }, []);

//   return (
//     <>
//       <div className="p-3">
//         <div className="flex gap-3 mt-5">
//           <div className="w-[320px] h-[48px]">
//             <input
//               type="text"
//               placeholder="Find by user name"
//               className="block p-4 h-full w-full rounded-2xl bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-gray-700"
//             />
//           </div>

//           <div className="flex gap-3 flex-none">
//             <form className="max-w-sm mx-auto">
//               <select
//                 id="roles"
//                 className="bg-gray-50 border border-gray-300 text-gray-700 outline-none text-sm rounded-lg block w-full p-2.5 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
//               >
//                 <option selected>All roles</option>
//                 <option value="US">United States</option>
//                 <option value="CA">Canada</option>
//                 <option value="FR">France</option>
//                 <option value="DE">Germany</option>
//               </select>
//             </form>
//             <form className="max-w-sm mx-auto">
//               <select
//                 id="time"
//                 className="bg-gray-50 border border-gray-300 text-gray-700 outline-none text-sm rounded-lg block w-full p-2.5 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
//               >
//                 <option selected>All time</option>
//                 <option value="US">United States</option>
//                 <option value="CA">Canada</option>
//                 <option value="FR">France</option>
//                 <option value="DE">Germany</option>
//               </select>
//             </form>
//           </div>
//         </div>
//       </div>

//       <div className="mt-6 overflow-x-auto">
//         <table className="w-full table-auto">
//           <thead>
//             <tr className="text-gray-600">
//               <th className="py-3 px-4 text-left">Name</th>
//               <th className="py-3 px-4 text-left">Services</th>
//               <th className="py-3 px-4 text-left whitespace-nowrap">Date And Time</th>
//               <th className="py-3 pr-8  text-right">Type</th>
//             </tr>
//           </thead>
//           <tbody>
//             {data.map((row, index) => (
//               <tr
//                 key={index}
//                 className=" border-b dark:border-gray-200"
//               >
//                 <td className="py-3 px-4">
//                   <div className="flex items-center gap-3">
//                     <img
//                       className="w-12 h-12 rounded-full"
//                       src={row.avatar}
//                       alt={row.name}
//                     />
//                     <div className="flex flex-col">
//                       <span className="font-semibold text-navy-700 dark:text-white">
//                         {row.name}
//                       </span>
//                       <span className="text-sm text-gray-500 dark:text-white">
//                         {row.role}
//                       </span>
//                     </div>
//                   </div>
//                 </td>
//                 <td className="py-3 px-4">{row.service}</td>
//                 <td className="py-3 px-4">
//                   {row.datetime && new Date(row.datetime).toLocaleString()}
//                 </td>
//                 <td className="py-3 px-4 text-right">
//                   <div
//                     className={`inline-block w-fit px-4 py-1 text-sm capitalize rounded-xl font-bold ${
//                       row.type === "Exit"
//                         ? "bg-red-100 text-red-600"
//                         : "bg-green-100 text-green-600"
//                     }`}
//                   >
//                     {row.type}
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <div className="flex items-center justify-between">
//         <div className="flex mt-8 gap-4 items-center">
//           <p className="ml-8 text-navy-700">Show rows per page</p>
//           <div>
//             <form className="max-w-sm mx-auto">
//               <select
//                 id="rows"
//                 className="bg-gray-50 border border-gray-300 text-navy-700 outline-none text-sm rounded-lg block p-1 dark:border-navy-700 dark:placeholder-navy-700 dark:text-white"
//               >
//                 <option selected>10</option>
//                 <option value="1">1</option>
//                 <option value="2">2</option>
//                 <option value="3">3</option>
//                 <option value="4">4</option>
//               </select>
//             </form>
//           </div>
//         </div>
//         <div className="mr-12">
//           <p className="text-gray-600">
//             <span className="text-navy-700">1-6 </span> of 32
//           </p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default EntriesAndExits;
import React, { useEffect, useState, useMemo } from "react";
import avatar from "assets/img/avatars/avatar4.png";
import GlobalTable from "components/global-table";
import { FiUsers } from "react-icons/fi";
import { AiOutlineLogout } from "react-icons/ai";
import { RiLogoutCircleLine } from "react-icons/ri";

const EntriesAndExits = () => {
  const statsData = [
    {
      title: "Total Members",
      count: 8412,
      icon: <FiUsers className="text-green-500 text-2xl" />,
      bgColor: "bg-green-100",
    },
    {
      title: "Entry",
      count: 8412,
      icon: <AiOutlineLogout className="text-green-500 text-2xl" />,
      bgColor: "bg-green-100",
    },
    {
      title: "Exit",
      count: 8412,
      icon: <RiLogoutCircleLine className="text-red-500 text-2xl" />,
      bgColor: "bg-red-100",
    },
  ];
  const [data, setData] = useState([]);

  useEffect(() => {
    setData([
      {
        name: "Vlad Mihalache",
        avatar: avatar,
        role: "Volunteer",
        service: "Service Name",
        datetime: new Date(),
        type: Math.random() > 0.5 ? "Entry" : "Exit",
      },
      {
        name: "John Smith",
        avatar: avatar,
        role: "Volunteer",
        service: "Service Name",
        datetime: new Date(),
        type: Math.random() > 0.5 ? "Entry" : "Exit",
      },
      {
        name: "Emma Johnson",
        avatar: avatar,
        role: "Volunteer",
        service: "Service Name",
        datetime: new Date(),
        type: Math.random() > 0.5 ? "Entry" : "Exit",
      },
    ]);
  }, []);

  const columns = useMemo(
    () => [
      {
        id: "name",
        label: "Name",
        render: (row) => (
          <div className="flex items-center gap-3">
            <img
              className="w-12 h-12 rounded-full"
              src={row.avatar}
              alt={row.name}
            />
            <div className="flex flex-col">
              <span className="font-semibold text-navy-700 dark:text-white">
                {row.name}
              </span>
              <span className="text-sm text-gray-500 dark:text-white">
                {row.role}
              </span>
            </div>
          </div>
        ),
      },
      {
        id: "service",
        label: "Services",
      },
      {
        id: "datetime",
        label: "Date And Time",
        render: (row) => new Date(row.datetime).toLocaleString(),
      },
      {
        id: "type",
        label: "Type",
        render: (row) => (
          <div
            className={`inline-block w-fit px-4 py-1 text-sm capitalize rounded-xl font-bold ${
              row.type === "Exit"
                ? "bg-red-100 text-red-600"
                : "bg-green-100 text-green-600"
            }`}
          >
            {row.type}
          </div>
        ),
      },
    ],
    []
  );

  return (
    <>
      <div className="mt-10 flex flex-col md:flex-row justify-center gap-6">
        {statsData.map((stat, index) => (
          <div
            key={index}
            className="flex items-center bg-white dark:bg-navy-900 shadow-md rounded-2xl p-6 w-full  space-x-4"
          >
            <div className={`p-4 rounded-full ${stat.bgColor} bg-opacity-20`}>
              {stat.icon}
            </div>
            <div>
              <p className="text-sm text-gray-500">{stat.title}</p>
              <p className="text-2xl font-semibold text-blue-800  dark:text-white">
                {stat.count.toLocaleString()}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="p-3">
        <div className="flex gap-3 mt-5">
          <div className="w-[320px] h-[48px]">
            <input
              type="text"
              placeholder="Find by user name"
              className="block p-4 h-full w-full rounded-2xl bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-gray-700"
            />
          </div>

          <div className="flex gap-3 flex-none">
            <form className="max-w-sm mx-auto">
              <select
                id="roles"
                className="bg-gray-50 border border-gray-300 text-gray-700 outline-none text-sm rounded-lg block w-full p-2.5 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
              >
                <option defaultValue>All roles</option>
                <option value="Volunteer">Volunteer</option>
                <option value="Admin">Admin</option>
              </select>
            </form>
            <form className="max-w-sm mx-auto">
              <select
                id="time"
                className="bg-gray-50 border border-gray-300 text-gray-700 outline-none text-sm rounded-lg block w-full p-2.5 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
              >
                <option defaultValue>All time</option>
                <option value="Today">Today</option>
                <option value="This Week">This Week</option>
              </select>
            </form>
          </div>
        </div>
      </div>

      <div className="mt-6">
        <GlobalTable columns={columns} data={data} />
      </div>

      <div className="flex items-center justify-between">
        <div className="flex mt-8 gap-4 items-center">
          <p className="ml-8 text-navy-700">Show rows per page</p>
          <div>
            <form className="max-w-sm mx-auto">
              <select
                id="rows"
                className="bg-gray-50 border border-gray-300 text-navy-700 outline-none text-sm rounded-lg block p-1 dark:border-navy-700 dark:placeholder-navy-700 dark:text-white"
              >
                <option defaultValue>10</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
            </form>
          </div>
        </div>
        <div className="mr-12">
          <p className="text-gray-600">
            <span className="text-navy-700">1-6 </span> of 32
          </p>
        </div>
      </div>
    </>
  );
};

export default EntriesAndExits;
